import React, { useState, useContext, useEffect, useMemo } from 'react';

//Material UI
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import FullscreenExitIcon from '@material-ui/icons/FullscreenExit';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@material-ui/core';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

//Contexts
import { store as mainStore } from 'store';

//APIs
import axios from 'api/axios';

//Packages
import moment from 'moment-jalaali';

//Hooks
import { useSearchParams } from 'hooks/useSearchParams';

//Components
import SelectStates from 'components/FormInputs/SelectStates';
import MultipyDatePicker from 'components/Select/MultipyDatePicker';
import ProgressiveButton from 'components/Button/ProgressiveButton';
import OrderListInterestesDrivers from 'components/Dialog/DriverInterests/OrderListInterestesDrivers';
import WeekDays from './WeekDays';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexFlow: 'column nowrap',
    '& > *:not(:last-child)': {
      marginBottom: theme.spacing(1),
    },
    height: '100vh',

    '& .helperText': {
      fontSize: '.8rem',
      marginLeft: '.2rem',
    },
  },
}));

const helperTextArray2 = [
  <div>
    رزرو تاریخ برای <span className="text-success blink_me fs-6 ">امروز</span>
  </div>,
  <div>
    رزرو تاریخ برای{' '}
    <span style={{ color: '#eb6f2d' }} className=" blink_me fs-6 ">
      فردا
    </span>
  </div>,
  <div>
    رزرو تاریخ برای{' '}
    <span style={{ color: 'rgb(81 3 207)' }} className="blink_me ">
      روز های آتی
    </span>
  </div>,
  ,
  ,
];

const DriverInterests = ({ onClose, driverId, refetchUserData, user }) => {
  const classes = useStyles();
  const { showMessage, showError } = useContext(mainStore);
  const [loading, setLoading] = useState(false);
  const [interests, setInterests] = useState([]);
  // const [books, setBooks] = useState([]);
  const [datesArray, setDatesArray] = useState([]);
  const [fullScreen, setFullScreen] = useState(false);
  const [params, deleteParams] = useSearchParams();
  const workDays = user?.workDays;
  const [weekDays, setWeekDays] = useState([]);
  const handleClose = async (agree) => {
    if (agree) {
      setLoading(true);
      if (!driverId) {
        onClose(interests);
        deleteParams([{ name: 'modal' }]);
        return;
      }
      try {
        const _states = interests?.map((s) => s.value);
        // const _books = books?.map((s) => s.value);
        const {
          data: { messages },
        } = await axios.post(`/api/v1/admin/users/driver/addInterests`, {
          driverId,
          states: _states,
          datesOfInterests: datesArray,
          workDays: weekDays,
        });
        showMessage(messages);
        await refetchUserData();
        onClose();
        deleteParams([{ name: 'modal' }]);
      } catch (error) {
        showError(error);
      } finally {
        setLoading(false);
        deleteParams([{ name: 'modal' }]);
      }
    }
  };

  const handleSelectState = (selection) => {
    setInterests(selection);
  };
  async function getTotalInterests() {
    try {
      const {
        data: { interests },
      } = await axios.get(`/api/v1/admin/users/driver/${driverId}/interests`);
      const _states = interests?.[0]?.states?.length
        ? interests[0].states.map((i) => ({
            value: i._id,
            label: i.title,
          }))
        : [];
      setInterests(_states);
      const dates = interests?.map((i) => i?.dateOfInterests);
      if (Array.isArray(dates) && dates?.length) {
        setDatesArray(dates.map((d) => moment(d)));
      } else {
        setDatesArray([]);
      }
    } catch (error) {
      showError(error);
    }
  }
  const handleChangeDates = (dates) => {
    setDatesArray(dates);
  };

  const hintText = useMemo(() => {
    let hint = [];
    const currentDayOfTheYear = moment().jDayOfYear();
    const arrayOfDatesSelected =
      (datesArray.length > 0 && datesArray?.map((item) => item.jDayOfYear())) ||
      [];

    if (arrayOfDatesSelected?.includes(currentDayOfTheYear))
      hint.push(helperTextArray2[0]);
    else hint.filter((item, i) => i === 0);

    if (arrayOfDatesSelected?.includes(currentDayOfTheYear + 1))
      hint.push(helperTextArray2[1]);
    else hint.filter((item, i) => i === 1);

    if (arrayOfDatesSelected.some((value) => value > currentDayOfTheYear + 1))
      hint.push(helperTextArray2[2]);
    else hint.filter((item, i) => i === 2);

    return hint;
  }, [datesArray]);

  useEffect(() => {
    if (!driverId) return;
    if (!params.get('modal')) return;
    getTotalInterests();
    // getBooks();
  }, [driverId, params.get('modal')]);
  useEffect(() => {
    setWeekDays([...workDays]);
  }, []);

  return (
    <Dialog
      open={params.get('modal') || false}
      onClose={() => deleteParams([{ name: 'modal' }])}
      aria-labelledby="form-dialog-title"
      fullWidth
      maxWidth={'md'}
      fullScreen={fullScreen}
    >
      <DialogTitle id="form-dialog-title">تعیین علایق راننده</DialogTitle>
      <DialogContent>
        <div className={classes.root}>
          <div>
            لطفاً استان‌های مورد علاقه راننده جهت مقصد بارگیری را مشخص نمائید.
          </div>
          <SelectStates
            placeholder="انتخاب استان‌ها جهت ارسال بارهای مورد علاقه"
            onSelect={handleSelectState}
            state={interests}
            isMulti
          />
          {driverId && (
            <>
              <MultipyDatePicker
                value={datesArray}
                onChange={handleChangeDates}
              />
              <Typography className={'helperText fs-7'}>{hintText}</Typography>
              <Divider className="bg-black mt-3" />
              <WeekDays weekDays={weekDays} setWeekDays={setWeekDays} />
              <div style={{ maxWidth: 'inherit' }}>
                <OrderListInterestesDrivers
                  fullScreen={fullScreen}
                  destinationStates={interests}
                  driverId={driverId}
                />
              </div>
            </>
          )}
        </div>
      </DialogContent>
      <DialogActions dir="ltr">
        <Button
          className="position-absolute"
          style={{ top: '5px', left: 0 }}
          onClick={() => setFullScreen(!fullScreen)}
        >
          {fullScreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
        </Button>

        <Button
          onClick={() => deleteParams([{ name: 'modal' }])}
          color="primary"
        >
          صرف نظر
        </Button>
        <ProgressiveButton
          startIcon
          onClick={() => handleClose(true)}
          variant={'contained'}
          autoFocus
          color="secondary"
          // disabled={loading || !interests?.length || !datesArray?.length}
          disabled={loading}
        >
          ذخیره
        </ProgressiveButton>
      </DialogActions>
    </Dialog>
  );
};

export default DriverInterests;
